import { render, staticRenderFns } from "./KnowledgeBaseSubCategory.vue?vue&type=template&id=142cf640&scoped=true&"
import script from "./KnowledgeBaseSubCategory.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseSubCategory.vue?vue&type=style&index=0&id=142cf640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142cf640",
  null
  
)

export default component.exports